import { Component, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Command, LabelCommand } from "@tylertech/commands-module";
import { ExecutionResult, UdfContext, UserDefinedFieldViewModel } from "@tylertech/tyler-api-types";
import { Activatable } from "../../interfaces/userDefinedField";
import { UserDefinedFieldService } from "../../services";
export interface UserDefinedFieldsDialogData
{
    readonly userDefinedFields: ReadonlyArray<UserDefinedFieldViewModel & Activatable>;
    readonly settings: UdfContext;
    readonly viewOnly: boolean;
}
@Component({
    selector: "user-defined-fields-dialog-component",
    templateUrl: "./userDefinedFieldDialog.tmpl.html",
    styleUrls: ["./userDefinedFieldDialog.component.scss"],
    standalone: false
})
export class UserDefinedFieldsDialogComponent implements OnInit
{
    private readonly dialogRef = inject<MatDialogRef<UserDefinedFieldsDialogComponent, Array<UserDefinedFieldViewModel> | undefined>>(MatDialogRef);
    private readonly data = inject<UserDefinedFieldsDialogData>(MAT_DIALOG_DATA);
    private $userDefinedFieldsService = inject(UserDefinedFieldService);

    private userDefinedFields: Array<UserDefinedFieldViewModel & Activatable>;
    readonly commands: ReadonlyArray<Command>;
    isLoaded: boolean;
    constructor()
    {
        this.commands = [
            new LabelCommand({
                label: "Cancel",
                action: () => this.cancel(),
                getEnabled: () => true,
            }),
            new LabelCommand({
                label: () => (this.viewOnly ? "Close" : "Done"),
                action: () => (this.viewOnly ? this.cancel() : this.done()),
                getEnabled: () => true,
            }),
        ];
    }

    private get settings(): UdfContext
    {
        return this.data.settings;
    }

    private get viewOnly(): boolean
    {
        return this.data.viewOnly;
    }

    private get originalUserDefinedFields(): ReadonlyArray<UserDefinedFieldViewModel>
    {
        return this.data.userDefinedFields;
    }

    get activeUserDefinedFields(): Array<UserDefinedFieldViewModel>
    {
        return this.userDefinedFields?.filter(x => x.Active) || [];
    }

    get isEmpty(): boolean
    {
        return this.activeUserDefinedFields.length === 0;
    }

    ngOnInit()
    {
        (this.originalUserDefinedFields
            ? Promise.resolve(this.originalUserDefinedFields)
            : this.$userDefinedFieldsService
                .Get(this.settings)
                .then(
                    (executionResult: ExecutionResult<Array<UserDefinedFieldViewModel & Activatable>>) =>
                        executionResult.Result
                )
        )
            .then((fields: Array<UserDefinedFieldViewModel & Activatable>) =>
            {
                this.userDefinedFields = fields.filter(u => u.IsVisible);
                this.userDefinedFields.forEach(udf =>
                {
                    if (!udf.Value || !udf.IsRequired)
                    {
                        return;
                    }
                    udf.Active = true;
                });
                this.userDefinedFields.sort((n1, n2) => n1.Sort - n2.Sort);
            })
            .finally(() =>
            {
                this.isLoaded = true;
            });
    }

    private cancel(): void
    {
        this.dialogRef.close();
    }

    private done(): void
    {
        if (!this.validate())
        {
            return;
        }
        this.dialogRef.close(this.userDefinedFields);
    }

    private validate(): boolean
    {
        return this.userDefinedFields.reduce((valid, field) => valid && (!field.IsRequired || !!field.Value), true);
    }
}
